import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

const Flex = ({ height, flex, direction, justify, alignItems, alignContent, alignSelf, flexGrow, ...props }) => (
  <div {...props} />
)

const CsgFlex = styled(Flex)`
  display: flex;
  flex-direction: ${props => props.direction};
  justify-content: ${props => props.justify};
  align-items: ${props => props.alignItems};
  align-items: ${props => props.alignItems};
  align-self: ${props => props.alignSelf};
  flex-grow: ${props => props.flexGrow};
  align-content: ${props => props.alignContent};
  flex: ${props => props.flex};
  flex-wrap: ${props => props.flexWrap};
  height: ${props => props.height};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

CsgFlex.defaultProps = {
  margin: '0',
  padding: '0',
  direction: 'row',
  justify: 'flex-start',
  alignItems: 'stretch',
  alignContent: 'stretch'
}

CsgFlex.propTypes = {
  height: PropTypes.any,
  margin: PropTypes.any,
  padding: PropTypes.any,
  flex: PropTypes.number,
  flexWrap: PropTypes.PropTypes.oneOf(['noWrap', 'wrap', 'wrap-reverse']),
  direction: PropTypes.oneOf(['row', 'column']),
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
  alignSelf: PropTypes.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  flexGrow: PropTypes.number
}

export default CsgFlex
